export const tabs = [
  {value: 'ALL', label: 'All'},
  {value: 'ACTIVE', label: 'Active'},
  {value: 'INACTIVE', label: 'Inactive'},
]

export const BannerColumnItems = ["Mobile", "Web", "Link", "State"]

export const BannerType = [
  {value: 'PATIENT', label: 'patient'},
  {value: 'Doctor', label: 'doctor'},
]


const groupOptions = [
  {
    value: 'products',
    label: 'Products',
    subGroupOptions: [
      {value: 'categories', label: 'Categories'},
      {value: 'brands', label: 'Brands'},
      // {value: 'featured', label: 'Featured'},
      {value: 'details', label: 'Detail'},
      // {value: 'shop', label: 'Shop'},
      {value: 'hot-sale', label: 'Hot'},
      {value: 'fresh-sale', label: 'Fresh'},
      {value: 'brand-day', label: 'Brand Day'},
      {value: 'brand-week', label: 'Brand Week'},
    ],
  },
  {
    value: 'brands',
    label: 'Brands',
    subGroupOptions: [
      {value: 'normal', label: 'All Brands'},
      {value: 'featured', label: 'Featured Brands'},
      {value: 'campaign', label: 'Brand Month'},
    ],
  },
  {
    value: 'flash-sale',
    label: 'Flash Sale', // on picking this option, api call garaune, ani data cha vane matra subGroupOptions dekhaune
    subGroupOptions: [
      {value: 'products', label: 'Products'},
      {value: 'brands', label: 'Brands'},
    ],
  },
  {
    value: 'product-campaigns',
    label: 'Product Campaign',
  },
  {
    value: 'pages',
    label: 'Pages',
  },
]


const screens = [
  {value: "HOME", label: "Homepage"},
  {value: "CART", label: "Cart Page"},
]

const users = ['Patient', 'Doctor']

const displayBrandSearch = (group, subGroup) => (group === 'products' && subGroup === 'brands') || (group === 'brands' && subGroup === 'flash');

const displayProductSearch = (group, subGroup) => group === 'products' && subGroup === 'details';

const displayCategorySearch = (group, subGroup) => group === 'products' && subGroup === 'categories';

const displayCampaignSearch = (group, subGroup) => group === 'brands' && subGroup === 'campaign';

const displayBrandDaySearch = (group, subGroup) => group === 'products' && subGroup === 'brand-day';

const displayBrandWeekSearch = (group, subGroup) => group === 'products' && subGroup === 'brand-week';

const displayProductCampaign = (group, subGroup) => group === "product-campaigns" && (subGroup === "normal" || subGroup === "discount")


export {
  groupOptions,
  screens,
  users,
  displayBrandSearch,
  displayProductSearch,
  displayCategorySearch,
  displayCampaignSearch,
  displayBrandDaySearch,
  displayBrandWeekSearch,
  displayProductCampaign
};
